<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-table :data="listData" border style="width: 100%">
      <el-table-column prop="dictValue" label="类型"></el-table-column>
      <el-table-column label="修改同时段可预约人次">
        <template slot-scope="scope">
          <el-input type="number" v-model="scope.row.dictType"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="save(scope.row.id,scope.row.dictType)" type="primary" size="small">保存</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import AllRouter from "@/router/";

export default {
  data() {
    return {
      listData: [],
      loading: false
    };
  },
  methods: {
    getData(val) {
      var that = this;
      that.loading = true;
      that.$axios
        .get(that.baseUrl + "/common/queryDic", {
          params: {
            code: val
          }
        })
        .then(res => {
          console.log(res);
          that.listData.push(res.data);
          that.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    save(id, val) {
      console.log(id);
      console.log(val);
      var that = this;
      that
        .$confirm("请确认修改此类型人数？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
        .then(() => {
          that.$axios
            .post(this.baseUrl + "/modifyDict", {
              id: id,
              dictType: val
            })
            .then(res => {
              console.log(res);
              that.refreshDict();
              if (res.data.code == 0) {
                that.$notify({
                  title: "保存成功",
                  message: "已成功修改报名人数限制！",
                  type: "success"
                });
              } else {
                that.$notify.error({
                  title: "保存失败",
                  message: "请检查您的网络！"
                });
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    refreshDict() {
      this.$axios
        .get(this.baseUrl + "/common/refreshDict")
        .then(res => {
          console.log(res);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted: function() {
    var that = this;
    that.getData("XL_SIGN_NUM");
    that.getData("ZY_SIGN_NUM");
  }
};
</script>